import smoothscroll from 'smoothscroll-polyfill';

function removePolyfill(arr) {
    arr.forEach(function (item) {
        if (item.hasOwnProperty('remove')) {
            return;
        }
        Object.defineProperty(item, 'remove', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function remove() {
                if (this.parentNode === null) {
                    return;
                }
                this.parentNode.removeChild(this);
            }
        });
    });
}

function closestPolyfill() {
    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }

    if (!Element.prototype.closest) {
        Element.prototype.closest = function (s) {
            var el = this;

            do {
                if (Element.prototype.matches.call(el, s)) return el;
                el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);

            return null;
        };
    }
}

function customEventPolyfill() {
    if (typeof window.CustomEvent === 'function') return false;

    function CustomEvent(event, params) {
        const parameters = params || { bubbles: false, cancelable: false, detail: null };
        const evt = document.createEvent('CustomEvent');

        evt.initCustomEvent(event, parameters.bubbles, parameters.cancelable, parameters.detail);

        return evt;
    }

    window.CustomEvent = CustomEvent;

    return true;
}


smoothscroll.polyfill();
removePolyfill([Element.prototype, CharacterData.prototype, DocumentType.prototype]);
closestPolyfill();
customEventPolyfill();
